/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
// import LoginImage from '../../../assets/logo/LoginImg.png';
// import TeachersDay from '../../../assets/logo/Teachers_Day.png'
// import GaneshIMage from '../../../assets/logo/Ganesh.jpg'
import NEET from '../../../assets/logo/Neet_image.png'
import JEE from '../../../assets/logo/JEE.png'
import KCET from '../../../assets/logo/KCET_Prep.png'
import KEAM from '../../../assets/logo/KEAM_Prep.png'
import CLAT from '../../../assets/logo/CLAT.png'
import SAT from '../../../assets/logo/LoginImg1.png';
import resetPasswordImg from '../../../assets/logo/restPassword.jpg';
import mailSentImg from '../../../assets/Images/email.png';

const SCREEN_IMAGES = {
  login: [process.env.REACT_APP_ENV === 'prod'? 'https://d17ueiwpvp2jfk.cloudfront.net/websiteImages/Loginimage.jpg' : 'https://dh0utea3ai9xq.cloudfront.net/websiteImages/Loginimage.jpg',NEET,JEE,KCET,KEAM, CLAT,SAT],
  forgot: [resetPasswordImg],
  sent: [mailSentImg],
  verify: [resetPasswordImg],
  emailVerify: [mailSentImg],
  resetSent: [resetPasswordImg],
};

const SCREEN_HEIGHTS = {
  login: 630,
  forgot: 500,      
  sent: 630,        
  verify: 630,
  emailVerify: 630, 
  resetSent: 522
};

// `firstImage` optionally replaces the first slide (used by the admin login-page preview).
export default function ImagePanel({ screen, firstImage }) {
  const defaultImages = SCREEN_IMAGES[screen] || SCREEN_IMAGES.login;
  const images = firstImage ? [firstImage, ...defaultImages.slice(1)] : defaultImages;
  const height = SCREEN_HEIGHTS[screen] || 630;
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
    if (images.length <= 1) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 4000);

    return () => clearInterval(interval);
  }, [screen]);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        minHeight: `${height}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Carousel
        autoPlay
        infiniteLoop
        showArrows={false}
        showThumbs={false}
        showStatus={false}
        showIndicators={false}
        selectedItem={index}
        style={{ width: '100%' }}
      >
        {images.map((image, idx) => (
          <Box
            key={idx}
            sx={{
              height: `${height}px`,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={image}
              alt={`slide-${idx}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '20px',
              }}
            />
          </Box>
        ))}
      </Carousel>
    </Box>
  );
}